import React from "react";
import { CardMedia } from "@mui/material";
import { getProfileImageByCurp } from "../services/profileImageCache.ts";

const PartnerPhoto = ({ curp }: { curp: string }) => {
  const [profileImage, setProfileImage] = React.useState(
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
  );
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleImageError = () => {
    setLoading(false);
    setError(true);
    setProfileImage(
      "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
    );
  };

  const getImage = () => {
    if (loading) return "/assets/img/loading.gif";
    if (error) return "/assets/img/avatar.jpg";
    return profileImage;
  };

  const fetchProfileImage = async () => {
    try {
      const url = await getProfileImageByCurp(curp);
      if (url) {
        setProfileImage(url);
      } else {
        setError(true);
      }
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (curp) {
      fetchProfileImage();
    }
  }, [curp]);

  return (
    <CardMedia
      component="img"
      image={getImage()}
      alt="Colaborador"
      onLoad={handleImageLoad}
      onError={handleImageError}
      className="rounded-circle"
      style={{ width: 50, height: 50 }}
    />
  );
};

export default PartnerPhoto;
